import { render, staticRenderFns } from "./LotDetailsHeader.vue?vue&type=template&id=587311bc"
import script from "./LotDetailsHeader.vue?vue&type=script&lang=js"
export * from "./LotDetailsHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports